export default __webpack_public_path__ + "static/media/swash-with-text.b73a600d.svg";